import { User } from "@shared/types";
import { Page } from "../enums/Page";
import { GameEventService } from "../services/GameEventService";

export class LoginRegisterBaseClass extends HTMLElement {
    private readonly _gameEventService: GameEventService = new GameEventService();

    /**
     * Creates User object with the given username and password.
     * @param username - The username input
     * @param password - The password input
     * @returns - The created User object
     */
    protected createUser(username: string, password: string, session?: string): User {
        const user: User = {
            username: username,
            password: password,
            session_id: session,
        };
        return user;
    }

    /**
     * Displays a message to the user for a specific time
     * @param element - The message element
     * @param text - The text to display
     */
    protected showMessage(element: HTMLElement, text: string): void {
        element.textContent = text;
        setTimeout(() => {
            element.innerHTML = "";
        }, 3000);
    }

    /**
     * Switch to a different page
     *
     * @param page Page to switch to
     */
    protected handleSwitchPage(page: Page): void {
        this._gameEventService.switchPage(page);
    }
}
